import ApiService from "@/services/api.service";
import { auth } from "@/services/firebase.service";

class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.errorCode = errorCode;
    }
}

const UserService = {
    login: async function(email, password) {
        try {
            const response = await auth.signInWithEmailAndPassword(
                email,
                password
            );
            return response;
        } catch (error) {
            throw new AuthenticationError(error.code, error.message);
        }
    },

    logout: async function() {
        try {
            const response = await auth.signOut();
            return response;
        } catch (error) {
            throw new AuthenticationError(
                error.response.status,
                error.response.data.detail
            );
        }
    },

    /** Register the current user */

    register: async function(payload) {
        try {
            const response = await ApiService.post("/register", payload);
            return response;
        } catch (error) {
            throw new AuthenticationError(
                error.response.status,
                error.response.data.message
            );
        }
    },

    calcBpiOutPut: async function(payload) {
        try {
            const response = await ApiService.post("/generateBPI", payload);
            return response;
        } catch (error) {
            throw new AuthenticationError(
                error.response.status,
                error.response.data.message
            );
        }
    },

    calcBpiOutPutVersionSimplify: async function(payload) {
        try {
            const response = await ApiService.post(
                "/generateBPISimplifier",
                payload
            );
            return response;
        } catch (error) {
            throw new AuthenticationError(
                error.response.status,
                error.response.data.message
            );
        }
    },

    downloadBpi: async function(payload) {
        const requestData = {
            method: "post",
            url: "/html2pdf",
            data: {
                ...payload
            },
            responseType: "arraybuffer",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/pdf"
            }
        };

        try {
            const response = await ApiService.customRequest(requestData);
            return response;
        } catch (error) {
            throw new AuthenticationError(
                error.response.status,
                error.response.data.message
            );
        }
    }
};

export default UserService;

export { UserService, AuthenticationError };
